import React from 'react'
import { motion } from 'framer-motion'

interface ISwitchProps extends React.HTMLProps<HTMLInputElement> {
  checked?: boolean
  onChange?: (e: React.FormEvent<HTMLInputElement>) => void
  disabled?: boolean
  variant?: 'default' | 'error' | 'success'
  label?: string
}

const Switch: React.FC<ISwitchProps> = ({
  checked,
  onChange,
  variant = 'default',
  label,
  ...rest
}) => {
  const [isFocusing, setIsFocusing] = React.useState<boolean>(false)

  const variants = {
    open: { backgroundColor: '#006aff' },
    closed: { backgroundColor: '#eee' }
  }

  return (
    <label className='switch-wrapper'>
      <motion.div
        className={`switch-container switch-container-${variant}`}
        data-active={isFocusing}
        animate={checked ? 'open' : 'closed'}
        style={{
          justifyContent: `flex-${checked ? 'end' : 'start'}`
        }}
        variants={variants}
        onFocus={() => setIsFocusing(true)}
        onBlur={() => setIsFocusing(false)}
        transition={{ ease: 'easeOut' }}
      >
        <motion.div
          layout
          className='switch-handle'
          transition={{ ease: 'easeOut' }}
        />
        <input
          type='checkbox'
          checked={checked}
          onChange={(e) => onChange && onChange(e)}
          {...rest}
        />
      </motion.div>
      {label && <p className='switch-label'>{label}</p>}
    </label>
  )
}

export default Switch
